import { useState } from 'react';
import { api, ApiError } from '../api/client';
import { useSession } from '../api/session';
import { Button, Card, Field, TextInput, ErrorNote } from '../components/ui';

export function ChangePassword() {
    const { user } = useSession();
    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState<ApiError | null>(null);
    const [busy, setBusy] = useState(false);

    const submit = async (event: React.FormEvent) => {
        event.preventDefault();
        setBusy(true);
        setError(null);

        try {
            await api.post('/api/auth/change-password', {
                currentPassword, newPassword, confirmPassword
            });

            // The change bumps the token version, so every session including this one is signed
            // out. Going back to the login form is the honest next step.
            window.location.assign('/login');
        } catch (caught) {
            setError(caught as ApiError);
            setBusy(false);
        }
    };

    return (
        <div className="max-w-md">
            <Card heading title="Change your password">
                {user?.mustChangePassword && (
                    <p className="mb-4 rounded-lg bg-amber-50 px-3 py-2 text-sm text-amber-800">
                        You need to choose your own password before you can use the rest of the product.
                    </p>
                )}

                <form onSubmit={submit} className="space-y-4">
                    {error && !error.errors && <ErrorNote message={error.message} />}

                    <Field label="Current password" error={error?.fieldError('currentPassword')}>
                        <TextInput
                            type="password"
                            value={currentPassword}
                            onChange={(e) => setCurrentPassword(e.target.value)}
                            autoComplete="current-password"
                            invalid={!!error?.fieldError('currentPassword')}
                        />
                    </Field>

                    <Field label="New password" error={error?.fieldError('newPassword')}>
                        <TextInput
                            type="password"
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                            autoComplete="new-password"
                            invalid={!!error?.fieldError('newPassword')}
                        />
                    </Field>

                    <Field label="Confirm new password" error={error?.fieldError('confirmPassword')}>
                        <TextInput
                            type="password"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            autoComplete="new-password"
                            invalid={!!error?.fieldError('confirmPassword')}
                        />
                    </Field>

                    <p className="text-xs text-slate-500">
                        Changing your password signs you out everywhere, including here.
                    </p>

                    <Button type="submit" busy={busy}>Change password</Button>
                </form>
            </Card>
        </div>
    );
}
